var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12.2942C8.19415 11.7269 7.41942 11.375 6.5625 11.375C4.87112 11.375 3.5 12.7461 3.5 14.4375C3.5 16.1289 4.87112 17.5 6.5625 17.5C8.25387 17.5 9.625 16.1289 9.625 14.4375C9.625 13.603 9.29127 12.8466 8.75 12.2942ZM8.75 12.2942L13.1526 7.89157M13.1526 7.89157L14.0332 7.01105L15.1103 5.91177M13.1526 7.89157L14.886 9.625M16.1875 4.8125L15.1103 5.91177M15.1103 5.91177L17.511 8.3125",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermission);
export default __webpack_public_path__ + "static/media/permission.f5199805148880dfbc7a172ea500d835.svg";
export { ForwardRef as ReactComponent };